export default __webpack_public_path__ + "static/media/NewcastleChest(COPD)TeamNEAS-CHESTReferralPathway-updated2019.c250ba15.jpg";